<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <multiple-upload
      :modelName="modelName"
      :mutationName="mutationName"
      :storeName="storeName"
      :disabled="disabled"
      :docId="docId"
    />
  </div>
</template>
<script>
export default {
  components: {
    MultipleUpload: () => import('./input/multiple_upload.vue'),
    SingleUpload: () => import('./input/upload-file.vue'),
  },
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
    'docId',
    'is_single',
  ],
}
</script>
